import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./styles/styles.css";
ReactDOM.render(<App />, document.getElementById("root"));
